import React, { useEffect, useState, useContext } from "react";
import { DatePicker, Select } from "antd";
import { AppContext } from "../../context";
import { FIELD_WIDTHS } from "../../config/layoutConfig";
import AHPSelect from "../../components/AHPSelect/AHPSelect";
import { EXPERIENCES } from "../experience/experiencesConstants";
import { openkit } from "../../library/database";
import { EVENT } from "./eventConstants";
import { getEventCategories, getEventDates, getEvents } from "./searchEvents";
import { useHistory } from "react-router-dom";
import { ENTITIES } from "../entitiesConfig";
import { languageName } from "../../library/language";

function EventFilter({ setStores }) {
  const info = useContext(AppContext);
  const [eventDates, setEventDates] = useState([]);
  const [eventCategories, setEventCategories] = useState([]);
  const [nextEvents, setNextEvents] = useState([]);
  const history = useHistory();

  const handleChange = (type, value) => {
    info.setEvent({
      ...info.event,
      [type]: value,
    });
  };

  const createEventList = (events, setNextEvents) => {
    const eventList = events.map((ev) => ({
      value: ev.slug,
      label: ev.eve_date + " " + languageName(ev.name, info.language),
    }));
    setNextEvents(eventList);
  };

  const languagePath = () => {
    return info.language === "pt" ? "" : "/" + info.language;
  };

  const disabledDate = (date) => {
    return !eventDates.includes(date.toISOString().split("T")[0]);
  };

  // set event categories in the calendar
  useEffect(() => {
    (async () => {
      const eventUniqueCategoriesArray = await getEventCategories(info);
      setEventCategories(eventUniqueCategoriesArray);
    })();
  }, [info.commonFilter.villages, info.commonFilter.name, info.event.date]);

  // set event dates in the calendar
  useEffect(() => {
    (async () => {
      const eventDatesArray = await getEventDates(info);
      setEventDates(eventDatesArray);
    })();
  }, [info.commonFilter.villages, info.commonFilter.name, info.event.category]);

  // search events for filter settings
  // villages, name, type and date
  useEffect(() => {
    (async () => {
      const events = await getEvents(info);
      setStores(events);
      createEventList(events, setNextEvents);
    })();
  }, [
    info.event.date,
    info.event.category,
    info.commonFilter.villages,
    info.commonFilter.name,
  ]);

  return (
    <div style={{ marginTop: 10 }}>
      <Select
        placeholder={info.t("type")}
        value={info.event?.category}
        options={eventCategories.map((c) => ({
          value: c,
          label: EVENT.CATEGORIES[c],
        }))}
        onChange={(value) => info.setEvent({ ...info.event, category: value })}
        allowClear
        style={{ width: FIELD_WIDTHS.M }}
        bordered={false}
      />
      <DatePicker
        disabledDate={disabledDate}
        value={info.event?.date}
        onChange={(value) => handleChange("date", value)}
        placeholder={info.t("date")}
        style={{ width: FIELD_WIDTHS.M }}
        bordered={false}
      />
      <div className="ahp-next-events">
        <Select
          placeholder={info.t("nextEvents")}
          options={nextEvents}
          onChange={(value) =>
            history.push(
              `${languagePath()}/${ENTITIES["event"].subDir}/${value}`
            )
          }
          allowClear
          style={{ width: FIELD_WIDTHS.XL }}
          bordered={false}
        />
      </div>
    </div>
  );
}

export default EventFilter;
